import { UPLOAD_RULES, uploadHint, uploadProps } from "utils/uploadRules";
import { EyeOutlined, MailOutlined, UploadOutlined } from "@ant-design/icons";
import { Button, Col, DatePicker, Form, Input, Modal, Popover, Row, Select, Spin, Table, Tooltip, Upload } from "antd";
import moment from "moment";
import { Fragment, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { uploadCovidVaccineCertificate } from "redux/actions/covidVaccineCertificate.action";
import { getUserList } from "redux/actions/getUserList.action";
import { uploadCertificate } from "redux/actions/uploadCertificate.action";
import { getVaccinationCertificate } from "redux/actions/vaccinationCertificate.action";
import { getApiArrayDetails, getPreSignedUrl, isValidArray } from "../../../utils/MyMUtils";
import Email from "./../mail";

import "./index.css";

const { Option } = Select;
const dateFormat = "DD-MM-YYYY";

function VaccinationCertificate() {
  const [userId, setUserId] = useState("");
  const [stateData, setstateData] = useState([]);
  const [staffIdsList, setStaffIdsList] = useState("");
  const [uploadInfo, setUploadInfo] = useState({});
  const [visible, setVisible] = useState(false);
  const [staffIdForUpload, setStaffIdForUpload] = useState("");
  const [visibleMail, setVisibleMail] = useState(false);
  const [form] = Form.useForm();
  const dispatch = useDispatch();

  const getVaccineCertificateList = useSelector((state) => getApiArrayDetails(state.getVaccineCertificate.data));

  const fileLoadingState = useSelector((state) => state.fileLoadingReducer.fileLoadingState);

  const getUserListData = useSelector((state) => getApiArrayDetails(state.getUserList.data));

  useEffect(() => {
    dispatch(getUserList());
    return () => {};
  }, []);

  useEffect(() => {
    form.resetFields();
  }, [visible]);

  useEffect(() => {
    if (getVaccineCertificateList && getVaccineCertificateList.length > 2) setstateData(getVaccineCertificateList);
    return () => {};
  }, [getVaccineCertificateList]);

  const getStaffIds = () => {
    if (isValidArray(getUserListData)) {
      let addIds = "";
      getUserListData.map((staff) => {
        addIds += staff.user_id + ",";
      });
      addIds = addIds.substring(0, addIds.length - 1);
      return addIds;
    }
    return null;
  };

  let StaffIds = getStaffIds();

  useEffect(() => {
    setStaffIdsList(StaffIds);
    dispatch(getVaccinationCertificate(StaffIds));
  }, [StaffIds]);

  const getStateList = () => {
    if (isValidArray(getUserListData)) {
      return getUserListData.map((staff) => {
        return (
          <Fragment key={staff?.user_id}>
            <Option value={staff?.user_id}>
              {staff?.first_name} {staff?.last_name}
            </Option>
          </Fragment>
        );
      });
    }
    return null;
  };

  const handleOnChange = (event) => {
    if (event[event.length - 1] == "0") {
      setStaffIdForUpload(staffIdsList);
      dispatch(getVaccinationCertificate(staffIdsList));
    }
    if (!isValidArray(event)) {
      setStaffIdForUpload(staffIdsList);
      dispatch(getVaccinationCertificate(staffIdsList));
    } else {
      setStaffIdForUpload(event);
      dispatch(getVaccinationCertificate(event));
    }
  };

  const setUploadModel = (elm) => {
    setVisible(true);
    setUserId(elm);
  };

  const uploadSettings = {
    ...uploadProps(UPLOAD_RULES.PDF),
    onChange: (info) => {
      let selectedFile = info.fileList;
      let file = null;
      let fileName;
      if (selectedFile.length > 0) {
        let fileToLoad = selectedFile[selectedFile.length - 1].originFileObj;
        fileName = fileToLoad.name;
        let reader = new FileReader();
        reader.onload = function (fileEvent) {
          file = fileEvent.target.result;
          let name = fileName.split(".");
          const uploadInfo = {
            filename: name[0],
            file: file,
            certificate_type: "influenza",
          };
          setUploadInfo(uploadInfo);
        };
        reader.readAsDataURL(fileToLoad);
      }
    },
  };

  const postNewUploadFunction = (data) => {
    dispatch(uploadCertificate(uploadInfo)).then((record) => {
      const uploadFinal = {
        user_id: userId.user_id,
        staff_name: userId.staff_name,
        vaccination_type: "influenza",
        vaccination_id: "1",
        comment: data?.comment,
        vaccination_date: moment(data.vaccination_date).format("YYYY-MM-DD"),
        pdf: record.payload.result.result,
      };
      dispatch(uploadCovidVaccineCertificate(uploadFinal)).then((record) => {
        if (record.payload.result.success === true) {
          if (staffIdForUpload) {
            dispatch(getVaccinationCertificate(staffIdForUpload || userId));
          } else {
            dispatch(getVaccinationCertificate(StaffIds));
          }
          toast.success(record.payload.result.message);
        } else {
          toast.error(record.payload.result.message);
        }
      });
    });
    setVisible(false);
  };

  const closePopover = () => {
    setVisibleMail(false);
  };

  const setMail = (elm) => {
    setVisibleMail(elm.id);
    if (visibleMail === elm.id) {
      setVisibleMail(false);
    }
  };

  const columns = [
    {
      title: "Name",
      dataIndex: "staff_name",
      key: "staff_name",
      width: "40%",

      sorter: (a, b) => a.staff_name.toUpperCase().charCodeAt(0) - b.staff_name.toUpperCase().charCodeAt(0),
      filters: getVaccineCertificateList
        ?.map((f) => {
          return { text: f.staff_name, value: f.staff_name };
        })
        .sort((a, b) => a.text.toUpperCase().charCodeAt(0) - b.text.toUpperCase().charCodeAt(0)),
      onFilter: (value, record) => record.staff_name.includes(value),
    },
    {
      title: "Action",
      dataIndex: "action",
      key: "action",
      width: "40%",
      render: (_, elm) => (
        <div>
          <span className="mr-3">
            {getVaccineCertificateList
              .filter((item) => elm.user_id == item.user_id)
              .map((item) => {
                return item?.evidence_photo ? (
                  <Tooltip title="View" color="rgb(47, 111, 224)">
                    <Button onClick={() => getPreSignedUrl(item.evidence_photo)}>{fileLoadingState !== item.evidence_photo ? <EyeOutlined /> : <Spin size="small" />}</Button>
                  </Tooltip>
                ) : (
                  <a>
                    <Tooltip title="View" color="rgb(47, 111, 224)">
                      <Button disabled>
                        <EyeOutlined style={{ color: "#00000040" }} />
                      </Button>
                    </Tooltip>
                  </a>
                );
              })}
          </span>
          <span className="mr-3">
            {getVaccineCertificateList
              .filter((item) => elm.user_id == item.user_id)
              .map((item) => {
                return item?.evidence_photo ? (
                  <Popover title="Additional Emails" content={<Email passData={elm} visibleMailprop={closePopover} />} visible={elm.id === visibleMail} trigger="click">
                    <Tooltip title="Mail" color="rgb(47, 111, 224)">
                      <Button onClick={() => setMail(elm)}>
                        <MailOutlined />
                      </Button>
                    </Tooltip>
                  </Popover>
                ) : (
                  <Tooltip title="Mail" color="rgb(47, 111, 224)">
                    <Button disabled>
                      <MailOutlined style={{ color: "#00000040" }} />
                    </Button>
                  </Tooltip>
                );
              })}
          </span>
          <span>
            <Tooltip title="Upload" color="rgb(47, 111, 224)">
              <Button onClick={() => setUploadModel(elm)}>
                <UploadOutlined />
              </Button>
            </Tooltip>
          </span>
        </div>
      ),
    },
  ];

  function onChange(value, dateString) {}

  function onOk(value) {}

  return (
    <>
      <Form layout="horizontal">
        <Row>
          <Col span={24}>
            <Form.Item>
              <div style={{ float: "right", width: "30%" }}>
                <Select mode="multiple" style={{ width: "100%" }} onChange={handleOnChange} placeholder="Select Staff" showSearch optionFilterProp="children" className="custom-multi-select">
                  {getStateList()}
                </Select>
              </div>
            </Form.Item>
          </Col>
        </Row>
        <Table
          loading={!isValidArray(getVaccineCertificateList)}
          columns={columns}
          dataSource={getVaccineCertificateList}
          rowKey="id"
          onChange={(pagination, filters, sorter, extra) => {
            setTimeout(() => {
              window.scrollTo({
                top: 0,
                behavior: "smooth",
              });
            });
          }}
        />
      </Form>
      <Modal title="Upload" centered visible={visible} footer={null} onCancel={() => setVisible(false)} width={500}>
        <Form onFinish={postNewUploadFunction} layout="vertical" form={form}>
          <Row gutter={24} className="justify-content-center">
            <Col md={24}>
              <Form.Item
                name="vaccination_date"
                label="Vaccination Date:"
                initialValue={moment(moment())}
                rules={[
                  {
                    required: true,
                    message: "Please enter the issue date.",
                  },
                ]}
              >
                <DatePicker
                  // defaultValue={moment(moment(), dateFormat)}
                  format={dateFormat}
                  onChange={onChange}
                  onOk={onOk}
                  // disabledDate={(current) => {
                  //   return moment().add(-1, "days") >= current;
                  // }}
                />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={24} className="justify-content-center">
            <Col md={24}>
              <Form.Item
                extra={uploadHint(UPLOAD_RULES.PDF)}
                name="file"
                label="File:"
                rules={[
                  {
                    required: true,
                    message: "Please upload the file.",
                  },
                ]}
              >
                <Upload {...uploadSettings} maxCount={1}>
                  {/* <Button onClick={() => policeCheckUpload(elm)}> */}

                  <Button onClick={() => setVisible(true)}>
                    <UploadOutlined />
                    Click to Upload
                  </Button>
                </Upload>
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={24} className="justify-content-center">
            <Col md={24} style={{ textAlign: "center" }}>
              <Form.Item name="comment" label="Comment:">
                <Input placeholder="Enter Comment" />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={24} className="justify-content-center">
            <Col md={24} style={{ textAlign: "center" }}>
              <Button htmlType="submit">Submit</Button>
            </Col>
          </Row>
        </Form>
      </Modal>
    </>
  );
}

export default VaccinationCertificate;
